export default "__VITE_ASSET__CBXN7BZE__"